import type { AuthTokens } from '@/types'
import type { ApiResponse, LoginRequest, RegisterRequest } from '@/types/api'
import { isSupabaseConfigured, supabase } from '@/lib/supabase'
import api from './api'

const AuthService = {
  async login(data: LoginRequest): Promise<AuthTokens> {
    const response = await api.post<ApiResponse<AuthTokens>>('/api/v1/auth/login', data)
    return response.data.data
  },

  async register(data: RegisterRequest): Promise<AuthTokens> {
    const response = await api.post<ApiResponse<AuthTokens>>('/api/v1/auth/register', data)
    return response.data.data
  },

  async refreshToken(refreshToken: string): Promise<AuthTokens> {
    const response = await api.post<ApiResponse<AuthTokens>>('/api/v1/auth/refresh', {
      refresh_token: refreshToken,
    })
    return response.data.data
  },

  async logout(): Promise<void> {
    try {
      await supabase.auth.signOut()
    } catch {
      // Ignore Supabase logout errors and continue local logout
    }

    try {
      await api.post('/api/v1/auth/logout')
    } catch {
      // Ignore logout errors and still clear local state
    }
  },

  async me(): Promise<AuthTokens['user']> {
    const response = await api.get<ApiResponse<AuthTokens['user']>>('/api/v1/auth/me')
    return response.data.data
  },

  async loginWithGoogle(): Promise<void> {
    if (!isSupabaseConfigured()) {
      throw new Error('Google OAuth via Supabase nao configurado no frontend.')
    }

    const redirectTo = `${window.location.origin}/auth/callback`
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo,
      },
    })

    if (error) {
      throw error
    }
  },

  async exchangeSupabaseGoogleToken(accessToken: string): Promise<AuthTokens> {
    const response = await api.post<ApiResponse<AuthTokens>>('/api/v1/auth/oauth/google/supabase', {
      access_token: accessToken,
    })
    return response.data.data
  },
}

export default AuthService
